import React from "react";
import SEO from "@/components/SEO";
import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import Services from "@/components/sections/Services";
import Marquee from "@/components/sections/Marquee";
import Manifesto from "@/components/sections/Manifesto";
import Zones from "@/components/sections/Zones";
import Reviews from "@/components/sections/Reviews";
import Faq from "@/components/sections/Faq";
import ScrapCrossLink from "@/components/sections/ScrapCrossLink";
import Footer from "@/components/sections/Footer";
import StickyCallBar from "@/components/StickyCallBar";
import WhatsAppFab from "@/components/WhatsAppFab";
import {
  localBusinessSchema, websiteSchema, breadcrumbSchema, faqPageSchema,
} from "@/lib/schemas";
import { SITE_URL } from "@/lib/site";

const HOME_TITLE = "Carroattrezzi Roma H24 | Soccorso Stradale Rapido - Carro Assistenza Roma";
const HOME_DESCRIPTION =
  "Carroattrezzi Roma H24 ⭐ Soccorso stradale rapido attivo 24/7 a Roma e provincia. Recupero auto, traino veicoli, batteria scarica, recupero moto. Chiama subito 06 9763 6222.";
const HOME_KEYWORDS =
  "carro attrezzi Roma, carroattrezzi Roma, soccorso stradale Roma, carro attrezzi Roma H24, recupero auto Roma, traino auto Roma, assistenza stradale Roma, carro attrezzi vicino a me";

export default function Home() {
  const jsonLd = [
    localBusinessSchema(),
    websiteSchema(),
    breadcrumbSchema([{ name: "Home", url: `${SITE_URL}/` }]),
    faqPageSchema(),
  ];

  return (
    <div className="min-h-screen bg-white text-navy" data-testid="page-home">
      <SEO
        title={HOME_TITLE}
        description={HOME_DESCRIPTION}
        canonical={`${SITE_URL}/`}
        keywords={HOME_KEYWORDS}
        image={`${SITE_URL}/og-image.png`}
        jsonLd={jsonLd}
      />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Manifesto />
        <Zones />
        <Reviews />
        <Faq />
        <ScrapCrossLink />
      </main>
      <Footer />
      <WhatsAppFab />
      <StickyCallBar />
      <div aria-hidden className="h-20 md:h-0" />
    </div>
  );
}
